import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sendtomarket',
  templateUrl: './sendtomarket.component.html',
  styleUrls: ['./sendtomarket.component.css']
})
export class SendtomarketComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
